import { css } from '@emotion/react';

const riskMetricTableStyles = css`
    .risk-metric-table * {
        border: 1px solid black;
    }

    .risk-metric-table {
        width: 90%;
        padding: 2%;
        margin: 0 auto;
    }

    .risk-metric-table-header {
        margin: 0 5% 5px;
        font-weight: bold;
        font-size: 1.2em;
    }
`;

export const riskMetricTableThemeStyles = css`
    .risk-metric-table * {
        border: 1px solid var(--default-text-color);
    }

    .risk-metric-table {
        width: 90%;
        padding: 2%;
        margin: 0 auto;
        font-family: var(--font-family-regular);
        color: var(--default-text-color);
        font-weight: var(--font-weight-regular);
        font-size: var(--font-size-regular);
    }

    .risk-metric-table-header {
        margin: 0 5% 5px;
        font-weight: bold;
        font-size: 1.2em;
        font-family: var(--font-family-regular);
        color: var(--default-text-color);
        font-weight: var(--font-weight-bold);
        font-size: var(--font-size-large);
    }

    table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            tr:nth-child(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }
        }
    }
`;

export default riskMetricTableStyles;
